import { message } from 'antd';
import React, { useEffect, useState } from 'react';
import apis from '../apis';
import { getQuery } from '@/common/utils';
import { goto } from '@/common/goto';

export default (props) => {
  const activityId = getQuery('activityId');
  const entry = getQuery('entry');
  const id = getQuery('id');
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (activityId) {
      apis
        .roomGetActType({ activityId })
        .then((res) => {
          if (res.ret === '0' && res.data) {
            setType(res.data.type);
            setLoading(false);
          } else {
            message.error(res.msg);
            setLoading(false);
          }
        })
        .catch((err) => {
          message.error(err);
          setLoading(false);
        });
    } else {
      // 如果没有activityId就不存在新老版本问题
      setLoading(false);
      setType(0);
    }
  }, [activityId]);

  if (loading || type === '') return null;

  if (type == 0) {
    // 旧版活动
    return props.children;
  } else {
    const pathname = window.location.pathname.split('/');
    if (pathname.length > 0 && pathname.indexOf('pools') !== -1) {
      if (entry == 0) {
        //新版本活动
        // 管理
        goto(`/activity-manage/myCreate/daily-activities-manager/materials${window.location.search}`, 'push');
      } else {
        // 报名 待德奇补充
        goto(
          `/activity-manage/myCreate/daily-activities-operation/pitEnroll/roomlist${window.location.search}`,
          'push'
        );
      }
    } else {
      const addUrl = pathname.slice(3).join('/') + window.location.search;
      // 收品池其他按钮跳转的页面
      if (entry == 0) {
        goto(`/activity-manage/myCreate/daily-activities-manager/${addUrl}`, 'push');
      } else {
        goto(`/activity-manage/myCreate/daily-activities-operation/${addUrl}`, 'push');
      }
    }
    return null;
  }
};
